import { render, staticRenderFns } from "./BonusPartial.vue?vue&type=template&id=879d596e"
import script from "../../js/components/partials/Bonus.js?vue&type=script&lang=js&external"
export * from "../../js/components/partials/Bonus.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports